import { EVENTS, MODALS } from 'common/domain/constants';
import { STATES } from 'common/domain/states';
import _ from 'lodash';

class CadastralReferenceMobileController {
  constructor
  (
    $window,
    $rootScope,
    $stateParams,
    $state,
    $timeout,
    GoBackDataService
  )
  {
    'ngInject';
    this.window = $window;
    this.rootScope = $rootScope;
    this.stateParams = $stateParams;
    this.state = $state;
    this.timeout = $timeout;
    this.goBackDataService = GoBackDataService;
    this.isMobileApp = $window.innerWidth < 1024;
    this.optionIsSelected = undefined;
    this.showQuestion = false;
    this.setTitlePage();
    if (this.stateParams.dataParams) {
      this.initFromSnapshot();
    }
  }

  $onInit() {
    if (_.isEmpty(this.loan) && this.isMobileApp) {
      return this.state.go(STATES.LOANS.MY_LOANS);
    }
  }

  getModal(item) {
    let modals = {
      'requestCadastral': $(MODALS.REQUEST_CADASTRAL),
      'questionCadastral': $(MODALS.QUESTION_CADASTRAL)
    };

    return modals[item];
  }

  initFromSnapshot() {
    const snapshot = this.stateParams.dataParams;
    this.loan = snapshot.loan;
    this.tempLoanObject = snapshot.tempLoanObject;
    this.simulation = snapshot.simulation;
    this.from = snapshot.from;
    if(this.from === 'sign-up') this.goBackDataService.setDataBackToSignUp(snapshot.paramsSignUp);
  }

  setTitlePage() {
    this.rootScope.$broadcast(EVENTS.CHANGE_TITLE, { title: 'LOANS.MY_LOANS.MODAL.MODAL_CADASTRAL_RERERENCE.TITLE' });
  }

  getClasses() {
    return {
      responsiveMobile: this.isMobileApp,
      container: this.isMobileApp,
      hpd: this.isMobileApp,
      'with-floating-action-buttons': this.isMobileApp,
    };
  }

  onSave($event) {
    this.error = $event.error;
    this.messageError = $event.messageError;
    this.getModal('requestCadastral').modal('show');
  }

  showCadastralReference() {
    this.showQuestion = false;
    this.getModal('questionCadastral').modal('hide');
  }

  showModalQuestion($event) {
    this.isCadastralCorrect = $event.isCadastralCorrect;
    this.tempLoanObject = $event.tempLoanObject.cadastralReferences[0];
    if (!this.isCadastralCorrect) {
      this.showQuestion = true;
      this.timeout(() => this.getModal('questionCadastral').modal('show'));
    } else {
      this.onClose();
    }
  }

  resetFormCadastral() {
    this.showQuestion = false;
    this.tempLoanObject = undefined;
    this.getModal('questionCadastral').modal('hide');
    if (this.error === 'failed') {
      this.error = undefined;
    }

    this.onClose();
  }

  onClose() {
    const errorApprove = this.error === 'approve';
    this.checkErrorOnCloseCadastral(errorApprove);
    if (errorApprove || this.error === undefined) {
      if (this.from === 'sign-up') this.closeFromSignUp();
      if (this.from === 'my-loans') this.closeFromMyLoans();
    }
  }

  onConfirmCloseCadastral() {
    this.error = undefined;
    this.onClose();
  }

  closeFromMyLoans() {
    this.state.go(STATES.LOANS.MY_LOANS);
  }

  closeFromSignUp() {
    const loanId = this.loan.id;
    const from = STATES.LOANS.CADASTRAL_REFERENCE;
    this.goBackDataService.setHideOrShowButtonCadastralSignUp(this.hideButtonCadastral);
    if (!this.showQuestion) this.state.go(STATES.LOANS.SIGN_UP, {loanId, from});
  }

  checkErrorOnCloseCadastral(errorApprove) {
    errorApprove ? this.hideButtonCadastral = true : this.hideButtonCadastral = false;
  }
}

export default CadastralReferenceMobileController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/myLoans/cadastralReferenceMobile/cadastralReferenceMobile.controller.js